// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommunityDetailContainer {
  width: 100%;
  max-width: 1050px;
  margin: 0 auto;
  padding: 24px 16px;
  color: #fff;
  font-family: "Instrument Sans", "Inter", sans-serif;
}

/* ─── Top Back Navigation Bar ─── */
.community-detail-nav-bar {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.community-back-btn {
  background: rgba(16, 34, 30, 0.65);
  border: 1px solid rgba(72, 209, 204, 0.22);
  color: #cbd5e1;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.community-back-btn:hover {
  background: rgba(72, 209, 204, 0.18);
  border-color: #48D1CC;
  color: #ffffff;
  transform: translateX(-3px);
  box-shadow: 0 4px 12px rgba(72, 209, 204, 0.15);
}

/* ─── Hero Header Card ─── */
.community-hero-header-card {
  position: relative;
  background: linear-gradient(180deg, #10221e 0%, #091714 100%);
  border: 1px solid rgba(72, 209, 204, 0.2);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.55), inset 0 1px 0 rgba(255, 255, 255, 0.08);
  margin-bottom: 24px;
}

.community-hero-banner {
  height: 150px;
  background: linear-gradient(135deg, #14352c 0%, #0a1f1a 100%);
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 16px 20px;
}

.community-hero-banner-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(16, 34, 30, 0.95) 100%);
  pointer-events: none;
}

.community-hero-top-badges {
  position: relative;
  z-index: 2;
}

.community-type-pill {
  background: rgba(4, 15, 12, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(72, 209, 204, 0.35);
  color: #f1f5f9;
  font-size: 11px;
  font-weight: 700;
  padding: 5px 12px;
  border-radius: 20px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.political-type-pill {
  background: rgba(20, 184, 166, 0.25);
  color: #2dd4bf;
  border-color: rgba(45, 212, 191, 0.45);
}

.city-type-pill {
  background: rgba(20, 184, 166, 0.25);
  color: #2dd4bf;
  border-color: rgba(45, 212, 191, 0.45);
}

.profession-type-pill {
  background: rgba(20, 184, 166, 0.25);
  color: #2dd4bf;
  border-color: rgba(45, 212, 191, 0.45);
}

.community-hero-content-wrapper {
  position: relative;
  padding: 0 28px 24px 28px;
  display: flex;
  align-items: flex-start;
  gap: 22px;
}

.community-hero-avatar-box {
  margin-top: -46px;
  position: relative;
  z-index: 3;
  flex-shrink: 0;
}

.community-hero-avatar {
  width: 92px;
  height: 92px;
  border-radius: 50%;
  object-fit: cover;
  border: 3.5px solid #10221e;
  outline: 2px solid rgba(72, 209, 204, 0.6);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);
  background: #14352c;
}

.community-hero-avatar-placeholder {
  width: 92px;
  height: 92px;
  border-radius: 50%;
  background: linear-gradient(135deg, #14352c 0%, #0d2620 100%);
  color: #48D1CC;
  font-size: 34px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3.5px solid #10221e;
  outline: 2px solid rgba(72, 209, 204, 0.5);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);
}

.community-hero-avatar-placeholder.political-avatar,
.community-hero-avatar-placeholder.city-avatar,
.community-hero-avatar-placeholder.profession-avatar {
  background: linear-gradient(135deg, #14352c 0%, #09201a 100%);
  color: #2dd4bf;
}

.community-hero-details {
  flex: 1 1;
  padding-top: 10px;
}

.community-hero-title-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 16px;
}

.community-hero-main-info {
  flex: 1 1;
  min-width: 260px;
}

.community-title-badges-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 8px;
}

.community-hero-title {
  font-size: 24px;
  font-weight: 800;
  margin: 0;
  color: #ffffff;
  letter-spacing: -0.3px;
}

.badge-gated-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.16);
  color: #e2e8f0;
  font-size: 11.5px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
}

.badge-city-pill,
.badge-political-pill,
.badge-profession-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: rgba(72, 209, 204, 0.12);
  border: 1px solid rgba(72, 209, 204, 0.35);
  color: #48D1CC;
  font-size: 11.5px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
}

.badge-open-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: rgba(59, 179, 174, 0.16);
  border: 1px solid rgba(59, 179, 174, 0.4);
  color: #48D1CC;
  font-size: 11.5px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
}

.community-hero-description {
  font-size: 14px;
  color: #94a3b8;
  line-height: 1.5;
  margin: 0 0 14px 0;
  max-width: 680px;
}

.community-hero-meta-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.meta-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  color: #718096;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 4px 12px;
  border-radius: 20px;
}

.meta-chip.verified-member-chip {
  background: rgba(59, 179, 174, 0.12);
  border-color: rgba(59, 179, 174, 0.35);
  color: #48D1CC;
  font-weight: 600;
}

.community-hero-cta {
  align-self: center;
}

.btn-hero-join {
  background: #3bb3ae;
  color: #061e1a;
  font-size: 13.5px;
  font-weight: 700;
  padding: 10px 24px;
  border-radius: 20px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 14px rgba(59, 179, 174, 0.3);
}

.btn-hero-join:hover {
  background: #4de3cf;
  box-shadow: 0 6px 20px rgba(59, 179, 174, 0.45);
  transform: translateY(-1px);
}

/* ─── LOCKED VIEW ─── */
.community-locked-container {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

.locked-shield-card {
  background: linear-gradient(135deg, rgba(20, 42, 36, 0.95), rgba(10, 24, 20, 0.98));
  border: 1px solid rgba(59, 179, 174, 0.35);
  border-radius: 20px;
  padding: 40px 32px;
  max-width: 620px;
  text-align: center;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.6);
}

.locked-icon-wrapper {
  width: 80px;
  height: 80px;
  background: rgba(59, 179, 174, 0.15);
  border: 2px solid rgba(59, 179, 174, 0.4);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
  color: #48D1CC;
}

.locked-title {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 10px 0;
}

.locked-desc {
  font-size: 14px;
  color: #a0aec0;
  line-height: 1.6;
  margin: 0 0 24px 0;
}

.locked-requirements-card {
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 24px;
  text-align: left;
}

.req-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.req-row:last-child {
  border-bottom: none;
}

.req-label {
  font-size: 13px;
  color: #718096;
}

.req-value {
  font-size: 13px;
  font-weight: 700;
  color: #fff;
}

.btn-unlock-cert {
  background: #3bb3ae;
  color: #0a1815;
  font-size: 15px;
  font-weight: 700;
  padding: 14px 28px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 16px rgba(59, 179, 174, 0.35);
  transition: all 0.2s ease;
}

.btn-unlock-cert:hover {
  transform: translateY(-2px);
  background: #4de3cf;
  box-shadow: 0 6px 22px rgba(59, 179, 174, 0.5);
}

.locked-shield-card.city-locked-card {
  border-color: rgba(20, 184, 166, 0.4);
  background: linear-gradient(135deg, rgba(13, 38, 35, 0.95), rgba(7, 21, 19, 0.98));
}

.locked-icon-wrapper.city-locked-icon {
  background: rgba(20, 184, 166, 0.15);
  border-color: rgba(20, 184, 166, 0.4);
}

.btn-unlock-city {
  background: linear-gradient(135deg, #14b8a6, #0d9488);
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  padding: 14px 28px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 16px rgba(20, 184, 166, 0.35);
  transition: all 0.2s ease;
}

.btn-unlock-city:hover {
  transform: translateY(-2px);
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  box-shadow: 0 6px 22px rgba(20, 184, 166, 0.5);
}

.locked-shield-card.political-locked-card {
  border-color: rgba(20, 184, 166, 0.4);
  background: linear-gradient(135deg, rgba(13, 38, 35, 0.95), rgba(7, 21, 19, 0.98));
}

.locked-icon-wrapper.political-locked-icon {
  background: rgba(20, 184, 166, 0.15);
  border-color: rgba(20, 184, 166, 0.4);
}

.btn-unlock-political {
  background: linear-gradient(135deg, #14b8a6, #0d9488);
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  padding: 14px 28px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 16px rgba(20, 184, 166, 0.35);
  transition: all 0.2s ease;
}

.btn-unlock-political:hover {
  transform: translateY(-2px);
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  box-shadow: 0 6px 22px rgba(20, 184, 166, 0.5);
}

.locked-shield-card.profession-locked-card {
  border-color: rgba(20, 184, 166, 0.4);
  background: linear-gradient(135deg, rgba(13, 38, 35, 0.95), rgba(7, 21, 19, 0.98));
}

.locked-icon-wrapper.profession-locked-icon {
  background: rgba(20, 184, 166, 0.15);
  border-color: rgba(20, 184, 166, 0.4);
}

.btn-unlock-profession {
  background: linear-gradient(135deg, #14b8a6, #0d9488);
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  padding: 14px 28px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 16px rgba(20, 184, 166, 0.35);
  transition: all 0.2s ease;
}

.btn-unlock-profession:hover {
  transform: translateY(-2px);
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  box-shadow: 0 6px 22px rgba(20, 184, 166, 0.5);
}

/* ─── UNLOCKED TABS & FEED ─── */
.community-tabs-header {
  display: flex;
  gap: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 24px;
}

.community-tabs-header {
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  margin-bottom: 24px;
}

.community-tab-nav {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: #94a3b8;
  font-size: 14px;
  font-weight: 600;
  padding: 12px 18px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  margin-bottom: -1px;
}

.community-tab-nav:hover {
  color: #fff;
}

.community-tab-nav.active {
  color: #48D1CC;
  border-bottom-color: #48D1CC;
  font-weight: 700;
}

/* Post Composer */
.post-composer-card {
  background: linear-gradient(180deg, #10221e 0%, #091714 100%);
  border: 1px solid rgba(72, 209, 204, 0.18);
  border-radius: 16px;
  padding: 22px;
  margin-bottom: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
}

.post-composer-card.composer-disabled {
  background: rgba(20, 28, 25, 0.65);
  border: 1px dashed rgba(72, 209, 204, 0.25);
}

.composer-disabled-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: rgba(72, 209, 204, 0.08);
  border: 1px solid rgba(72, 209, 204, 0.25);
  border-radius: 10px;
  padding: 10px 14px;
  margin-bottom: 16px;
}

.composer-disabled-text {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #e2e8f0;
  font-weight: 500;
}

.btn-inline-join {
  background: #48D1CC;
  color: #091714;
  font-size: 12px;
  font-weight: 700;
  padding: 6px 14px;
  border-radius: 14px;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.btn-inline-join:hover:not(:disabled) {
  background: #2dd4bf;
}

.btn-inline-join:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.composer-title {
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 14px 0;
  color: #f1f5f9;
}

.composer-input-title {
  width: 100%;
  font-family: inherit;
  padding: 12px 16px;
  background: rgba(16, 34, 30, 0.65);
  border: 1px solid rgba(72, 209, 204, 0.18);
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  outline: none;
  margin-bottom: 12px;
  transition: all 0.2s ease;
}

.composer-input-title:focus,
.composer-textarea:focus {
  border-color: #48D1CC;
  background: rgba(16, 34, 30, 0.95);
  box-shadow: 0 0 0 3px rgba(72, 209, 204, 0.12);
}

.composer-textarea {
  width: 100%;
  font-family: inherit;
  padding: 12px 16px;
  background: rgba(16, 34, 30, 0.65);
  border: 1px solid rgba(72, 209, 204, 0.18);
  border-radius: 10px;
  color: #fff;
  font-size: 13.5px;
  line-height: 1.5;
  outline: none;
  resize: vertical;
  margin-bottom: 14px;
  transition: all 0.2s ease;
}

.post-composer-card .composer-input-title:disabled,
.post-composer-card .composer-textarea:disabled,
.comment-reply-form .reply-input:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background: rgba(255, 255, 255, 0.02);
  border-color: rgba(255, 255, 255, 0.05);
}

.composer-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

/* Composer Attachment Buttons Toolbar */
.composer-attachment-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-composer-attach {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: rgba(72, 209, 204, 0.08);
  border: 1px solid rgba(72, 209, 204, 0.25);
  color: #48D1CC;
  font-size: 12.5px;
  font-weight: 600;
  padding: 8px 14px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.btn-composer-attach:hover:not(:disabled) {
  background: rgba(72, 209, 204, 0.18);
  border-color: #48D1CC;
  transform: translateY(-1px);
}

.btn-composer-attach.attached {
  background: rgba(72, 209, 204, 0.22);
  border-color: #48D1CC;
  color: #fff;
  box-shadow: 0 0 12px rgba(72, 209, 204, 0.2);
}

.btn-composer-attach:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  border-color: rgba(255, 255, 255, 0.08);
  color: #64748b;
}

/* Composer Attachments Tray */
.composer-attachments-tray {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 14px;
}

.composer-attachment-preview {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(16, 34, 30, 0.7);
  border: 1px solid rgba(72, 209, 204, 0.25);
  animation: fadeInAttachment 0.2s ease;
}

@keyframes fadeInAttachment {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}

.composer-attachment-preview.ballot-preview {
  border-left: 3px solid #48D1CC;
}

.composer-attachment-preview.shorts-preview {
  border-left: 3px solid #2dd4bf;
}

.composer-preview-icon {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background: rgba(72, 209, 204, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.composer-preview-media {
  width: 36px;
  height: 48px;
  border-radius: 6px;
  overflow: hidden;
  background: #000;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.composer-preview-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.composer-preview-thumb-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
}

.composer-preview-info {
  flex: 1 1;
  min-width: 0;
}

.composer-preview-label {
  display: block;
  font-size: 10.5px;
  font-weight: 700;
  color: #48D1CC;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 2px;
}

.composer-preview-title {
  font-size: 13.5px;
  font-weight: 600;
  color: #f8fafc;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.composer-preview-sub {
  font-size: 11.5px;
  color: #94a3b8;
  margin-top: 2px;
  display: block;
}

.btn-composer-remove-attachment {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #94a3b8;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.btn-composer-remove-attachment:hover {
  background: rgba(239, 68, 68, 0.2);
  border-color: rgba(239, 68, 68, 0.4);
  color: #f87171;
}

.btn-post-submit {
  background: #3bb3ae;
  color: #091714;
  font-size: 13px;
  font-weight: 700;
  padding: 9px 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.btn-post-submit:hover:not(:disabled) {
  background: #4de3cf;
}

.btn-post-submit:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  background: #2a3d38;
  color: #718096;
}

/* Post Cards */
.post-card {
  background: linear-gradient(180deg, #10221e 0%, #091714 100%);
  border: 1px solid rgba(72, 209, 204, 0.18);
  border-radius: 16px;
  padding: 22px;
  margin-bottom: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

.post-card.announcement {
  border-left: 4px solid #f56565;
}

.post-card.pinned {
  border-left: 4px solid #5e72e4;
}

.post-badges-row {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.badge-announcement {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(245, 101, 101, 0.2);
  color: #feb2b2;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 8px;
}

.badge-pinned {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(94, 114, 228, 0.2);
  color: #c3dafe;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 8px;
}

.post-author-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.post-author-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.post-author-avatar-placeholder {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3bb3ae, #15433d);
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.post-author-meta {
  flex: 1 1;
}

.post-author-name {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 6px;
}

.badge-admin-tag {
  background: #3bb3ae;
  color: #0d1e1a;
  font-size: 9px;
  font-weight: 700;
  padding: 1px 6px;
  border-radius: 6px;
}

.badge-tier-tag {
  background: rgba(59, 179, 174, 0.2);
  border: 1px solid rgba(59, 179, 174, 0.4);
  color: #48D1CC;
  font-size: 9px;
  font-weight: 700;
  padding: 1px 6px;
  border-radius: 6px;
}

.post-date {
  font-size: 11px;
  color: #718096;
}

.btn-delete-post {
  background: transparent;
  border: none;
  color: #718096;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: color 0.2s ease;
}

.btn-delete-post:hover {
  color: #e53e3e;
}

.btn-delete-comment {
  background: transparent;
  border: none;
  color: #718096;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  transition: color 0.2s ease;
  margin-left: 6px;
}

.btn-delete-comment:hover {
  color: #e53e3e;
}

.post-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px 0;
}

.post-body {
  font-size: 14px;
  color: #cbd5e0;
  line-height: 1.6;
  margin: 0 0 16px 0;
  white-space: pre-wrap;
}

/* Comments */
.post-comments-box {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  padding: 14px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.comments-count-label {
  font-size: 12px;
  font-weight: 700;
  color: #718096;
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 12px;
}

.comment-item {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 8px;
}

.comment-author-name {
  font-size: 12px;
  font-weight: 700;
  color: #e2e8f0;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.comment-time {
  font-size: 10px;
  font-weight: 400;
  color: #718096;
  margin-left: auto;
}

.comment-text {
  font-size: 13px;
  color: #a0aec0;
  margin: 0;
}

.comment-reply-form {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.reply-input {
  flex: 1 1;
  font-family: inherit;
  background: rgba(16, 34, 30, 0.65);
  border: 1px solid rgba(72, 209, 204, 0.18);
  border-radius: 20px;
  padding: 8px 16px;
  color: #fff;
  font-size: 13px;
  outline: none;
  transition: all 0.2s ease;
}

.reply-input:focus {
  border-color: #48D1CC;
  background: rgba(16, 34, 30, 0.95);
  box-shadow: 0 0 0 3px rgba(72, 209, 204, 0.12);
}

.btn-reply-send {
  background: #48D1CC;
  color: #091714;
  font-size: 12px;
  font-weight: 700;
  padding: 6px 18px;
  min-width: 68px;
  height: 34px;
  border-radius: 20px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.btn-reply-send:hover:not(:disabled) {
  background: #2dd4bf;
}

.btn-reply-send:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* Members Grid */
.members-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}

.member-card {
  background: #141c19;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.member-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.member-avatar-placeholder {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3bb3ae, #15433d);
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.member-info {
  flex: 1 1;
}

.member-name {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 2px 0;
}

.member-username {
  font-size: 12px;
  color: #718096;
  display: block;
  margin-bottom: 6px;
}

.member-badge-tier {
  display: inline-flex;
  align-items: center;
  background: rgba(59, 179, 174, 0.2);
  border: 1px solid rgba(59, 179, 174, 0.4);
  color: #48D1CC;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 8px;
}

/* Loading */
.community-detail-loading,
.community-detail-error,
.feed-loading,
.feed-empty {
  text-align: center;
  padding: 60px 20px;
  color: #718096;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Communities/CommunityDetail/CommunityDetail.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,mDAAmD;AACrD;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kDAAkD;EAClD,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,oFAAoF;EACpF,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,wFAAwF;EACxF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,0CAA0C;EAC1C,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;;;EAGE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,qCAAqC;EACrC,2CAA2C;EAC3C,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mFAAmF;EACnF,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,kFAAkF;AACpF;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,kFAAkF;AACpF;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,kFAAkF;AACpF;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,SAAS;EACT,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,6DAA6D;EAC7D,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;EAGE,mBAAmB;EACnB,YAAY;EACZ,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,6DAA6D;EAC7D,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;;;;EAIE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".CommunityDetailContainer {\n  width: 100%;\n  max-width: 1050px;\n  margin: 0 auto;\n  padding: 24px 16px;\n  color: #fff;\n  font-family: \"Instrument Sans\", \"Inter\", sans-serif;\n}\n\n/* ─── Top Back Navigation Bar ─── */\n.community-detail-nav-bar {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.community-back-btn {\n  background: rgba(16, 34, 30, 0.65);\n  border: 1px solid rgba(72, 209, 204, 0.22);\n  color: #cbd5e1;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 8px 16px;\n  border-radius: 12px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.community-back-btn:hover {\n  background: rgba(72, 209, 204, 0.18);\n  border-color: #48D1CC;\n  color: #ffffff;\n  transform: translateX(-3px);\n  box-shadow: 0 4px 12px rgba(72, 209, 204, 0.15);\n}\n\n/* ─── Hero Header Card ─── */\n.community-hero-header-card {\n  position: relative;\n  background: linear-gradient(180deg, #10221e 0%, #091714 100%);\n  border: 1px solid rgba(72, 209, 204, 0.2);\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.55), inset 0 1px 0 rgba(255, 255, 255, 0.08);\n  margin-bottom: 24px;\n}\n\n.community-hero-banner {\n  height: 150px;\n  background: linear-gradient(135deg, #14352c 0%, #0a1f1a 100%);\n  background-size: cover;\n  background-position: center;\n  position: relative;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n  padding: 16px 20px;\n}\n\n.community-hero-banner-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(16, 34, 30, 0.95) 100%);\n  pointer-events: none;\n}\n\n.community-hero-top-badges {\n  position: relative;\n  z-index: 2;\n}\n\n.community-type-pill {\n  background: rgba(4, 15, 12, 0.75);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(72, 209, 204, 0.35);\n  color: #f1f5f9;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 5px 12px;\n  border-radius: 20px;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.political-type-pill {\n  background: rgba(20, 184, 166, 0.25);\n  color: #2dd4bf;\n  border-color: rgba(45, 212, 191, 0.45);\n}\n\n.city-type-pill {\n  background: rgba(20, 184, 166, 0.25);\n  color: #2dd4bf;\n  border-color: rgba(45, 212, 191, 0.45);\n}\n\n.profession-type-pill {\n  background: rgba(20, 184, 166, 0.25);\n  color: #2dd4bf;\n  border-color: rgba(45, 212, 191, 0.45);\n}\n\n.community-hero-content-wrapper {\n  position: relative;\n  padding: 0 28px 24px 28px;\n  display: flex;\n  align-items: flex-start;\n  gap: 22px;\n}\n\n.community-hero-avatar-box {\n  margin-top: -46px;\n  position: relative;\n  z-index: 3;\n  flex-shrink: 0;\n}\n\n.community-hero-avatar {\n  width: 92px;\n  height: 92px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3.5px solid #10221e;\n  outline: 2px solid rgba(72, 209, 204, 0.6);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);\n  background: #14352c;\n}\n\n.community-hero-avatar-placeholder {\n  width: 92px;\n  height: 92px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #14352c 0%, #0d2620 100%);\n  color: #48D1CC;\n  font-size: 34px;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 3.5px solid #10221e;\n  outline: 2px solid rgba(72, 209, 204, 0.5);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);\n}\n\n.community-hero-avatar-placeholder.political-avatar,\n.community-hero-avatar-placeholder.city-avatar,\n.community-hero-avatar-placeholder.profession-avatar {\n  background: linear-gradient(135deg, #14352c 0%, #09201a 100%);\n  color: #2dd4bf;\n}\n\n.community-hero-details {\n  flex: 1;\n  padding-top: 10px;\n}\n\n.community-hero-title-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.community-hero-main-info {\n  flex: 1;\n  min-width: 260px;\n}\n\n.community-title-badges-wrap {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.community-hero-title {\n  font-size: 24px;\n  font-weight: 800;\n  margin: 0;\n  color: #ffffff;\n  letter-spacing: -0.3px;\n}\n\n.badge-gated-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  color: #e2e8f0;\n  font-size: 11.5px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 20px;\n}\n\n.badge-city-pill,\n.badge-political-pill,\n.badge-profession-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  background: rgba(72, 209, 204, 0.12);\n  border: 1px solid rgba(72, 209, 204, 0.35);\n  color: #48D1CC;\n  font-size: 11.5px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 20px;\n}\n\n.badge-open-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  background: rgba(59, 179, 174, 0.16);\n  border: 1px solid rgba(59, 179, 174, 0.4);\n  color: #48D1CC;\n  font-size: 11.5px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 20px;\n}\n\n.community-hero-description {\n  font-size: 14px;\n  color: #94a3b8;\n  line-height: 1.5;\n  margin: 0 0 14px 0;\n  max-width: 680px;\n}\n\n.community-hero-meta-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.meta-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12.5px;\n  color: #718096;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 4px 12px;\n  border-radius: 20px;\n}\n\n.meta-chip.verified-member-chip {\n  background: rgba(59, 179, 174, 0.12);\n  border-color: rgba(59, 179, 174, 0.35);\n  color: #48D1CC;\n  font-weight: 600;\n}\n\n.community-hero-cta {\n  align-self: center;\n}\n\n.btn-hero-join {\n  background: #3bb3ae;\n  color: #061e1a;\n  font-size: 13.5px;\n  font-weight: 700;\n  padding: 10px 24px;\n  border-radius: 20px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 14px rgba(59, 179, 174, 0.3);\n}\n\n.btn-hero-join:hover {\n  background: #4de3cf;\n  box-shadow: 0 6px 20px rgba(59, 179, 174, 0.45);\n  transform: translateY(-1px);\n}\n\n/* ─── LOCKED VIEW ─── */\n.community-locked-container {\n  display: flex;\n  justify-content: center;\n  padding: 20px 0;\n}\n\n.locked-shield-card {\n  background: linear-gradient(135deg, rgba(20, 42, 36, 0.95), rgba(10, 24, 20, 0.98));\n  border: 1px solid rgba(59, 179, 174, 0.35);\n  border-radius: 20px;\n  padding: 40px 32px;\n  max-width: 620px;\n  text-align: center;\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.6);\n}\n\n.locked-icon-wrapper {\n  width: 80px;\n  height: 80px;\n  background: rgba(59, 179, 174, 0.15);\n  border: 2px solid rgba(59, 179, 174, 0.4);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 20px auto;\n  color: #48D1CC;\n}\n\n.locked-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 10px 0;\n}\n\n.locked-desc {\n  font-size: 14px;\n  color: #a0aec0;\n  line-height: 1.6;\n  margin: 0 0 24px 0;\n}\n\n.locked-requirements-card {\n  background: rgba(0, 0, 0, 0.4);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 16px 20px;\n  margin-bottom: 24px;\n  text-align: left;\n}\n\n.req-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.req-row:last-child {\n  border-bottom: none;\n}\n\n.req-label {\n  font-size: 13px;\n  color: #718096;\n}\n\n.req-value {\n  font-size: 13px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.btn-unlock-cert {\n  background: #3bb3ae;\n  color: #0a1815;\n  font-size: 15px;\n  font-weight: 700;\n  padding: 14px 28px;\n  border-radius: 12px;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 16px rgba(59, 179, 174, 0.35);\n  transition: all 0.2s ease;\n}\n\n.btn-unlock-cert:hover {\n  transform: translateY(-2px);\n  background: #4de3cf;\n  box-shadow: 0 6px 22px rgba(59, 179, 174, 0.5);\n}\n\n.locked-shield-card.city-locked-card {\n  border-color: rgba(20, 184, 166, 0.4);\n  background: linear-gradient(135deg, rgba(13, 38, 35, 0.95), rgba(7, 21, 19, 0.98));\n}\n\n.locked-icon-wrapper.city-locked-icon {\n  background: rgba(20, 184, 166, 0.15);\n  border-color: rgba(20, 184, 166, 0.4);\n}\n\n.btn-unlock-city {\n  background: linear-gradient(135deg, #14b8a6, #0d9488);\n  color: #ffffff;\n  font-size: 15px;\n  font-weight: 700;\n  padding: 14px 28px;\n  border-radius: 12px;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 16px rgba(20, 184, 166, 0.35);\n  transition: all 0.2s ease;\n}\n\n.btn-unlock-city:hover {\n  transform: translateY(-2px);\n  background: linear-gradient(135deg, #2dd4bf, #14b8a6);\n  box-shadow: 0 6px 22px rgba(20, 184, 166, 0.5);\n}\n\n.locked-shield-card.political-locked-card {\n  border-color: rgba(20, 184, 166, 0.4);\n  background: linear-gradient(135deg, rgba(13, 38, 35, 0.95), rgba(7, 21, 19, 0.98));\n}\n\n.locked-icon-wrapper.political-locked-icon {\n  background: rgba(20, 184, 166, 0.15);\n  border-color: rgba(20, 184, 166, 0.4);\n}\n\n.btn-unlock-political {\n  background: linear-gradient(135deg, #14b8a6, #0d9488);\n  color: #ffffff;\n  font-size: 15px;\n  font-weight: 700;\n  padding: 14px 28px;\n  border-radius: 12px;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 16px rgba(20, 184, 166, 0.35);\n  transition: all 0.2s ease;\n}\n\n.btn-unlock-political:hover {\n  transform: translateY(-2px);\n  background: linear-gradient(135deg, #2dd4bf, #14b8a6);\n  box-shadow: 0 6px 22px rgba(20, 184, 166, 0.5);\n}\n\n.locked-shield-card.profession-locked-card {\n  border-color: rgba(20, 184, 166, 0.4);\n  background: linear-gradient(135deg, rgba(13, 38, 35, 0.95), rgba(7, 21, 19, 0.98));\n}\n\n.locked-icon-wrapper.profession-locked-icon {\n  background: rgba(20, 184, 166, 0.15);\n  border-color: rgba(20, 184, 166, 0.4);\n}\n\n.btn-unlock-profession {\n  background: linear-gradient(135deg, #14b8a6, #0d9488);\n  color: #ffffff;\n  font-size: 15px;\n  font-weight: 700;\n  padding: 14px 28px;\n  border-radius: 12px;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 16px rgba(20, 184, 166, 0.35);\n  transition: all 0.2s ease;\n}\n\n.btn-unlock-profession:hover {\n  transform: translateY(-2px);\n  background: linear-gradient(135deg, #2dd4bf, #14b8a6);\n  box-shadow: 0 6px 22px rgba(20, 184, 166, 0.5);\n}\n\n/* ─── UNLOCKED TABS & FEED ─── */\n.community-tabs-header {\n  display: flex;\n  gap: 12px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  margin-bottom: 24px;\n}\n\n.community-tabs-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  margin-bottom: 24px;\n}\n\n.community-tab-nav {\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  color: #94a3b8;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 12px 18px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.2s ease;\n  margin-bottom: -1px;\n}\n\n.community-tab-nav:hover {\n  color: #fff;\n}\n\n.community-tab-nav.active {\n  color: #48D1CC;\n  border-bottom-color: #48D1CC;\n  font-weight: 700;\n}\n\n/* Post Composer */\n.post-composer-card {\n  background: linear-gradient(180deg, #10221e 0%, #091714 100%);\n  border: 1px solid rgba(72, 209, 204, 0.18);\n  border-radius: 16px;\n  padding: 22px;\n  margin-bottom: 24px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);\n}\n\n.post-composer-card.composer-disabled {\n  background: rgba(20, 28, 25, 0.65);\n  border: 1px dashed rgba(72, 209, 204, 0.25);\n}\n\n.composer-disabled-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  background: rgba(72, 209, 204, 0.08);\n  border: 1px solid rgba(72, 209, 204, 0.25);\n  border-radius: 10px;\n  padding: 10px 14px;\n  margin-bottom: 16px;\n}\n\n.composer-disabled-text {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #e2e8f0;\n  font-weight: 500;\n}\n\n.btn-inline-join {\n  background: #48D1CC;\n  color: #091714;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 6px 14px;\n  border-radius: 14px;\n  border: none;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n}\n\n.btn-inline-join:hover:not(:disabled) {\n  background: #2dd4bf;\n}\n\n.btn-inline-join:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.composer-title {\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0 0 14px 0;\n  color: #f1f5f9;\n}\n\n.composer-input-title {\n  width: 100%;\n  font-family: inherit;\n  padding: 12px 16px;\n  background: rgba(16, 34, 30, 0.65);\n  border: 1px solid rgba(72, 209, 204, 0.18);\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  outline: none;\n  margin-bottom: 12px;\n  transition: all 0.2s ease;\n}\n\n.composer-input-title:focus,\n.composer-textarea:focus {\n  border-color: #48D1CC;\n  background: rgba(16, 34, 30, 0.95);\n  box-shadow: 0 0 0 3px rgba(72, 209, 204, 0.12);\n}\n\n.composer-textarea {\n  width: 100%;\n  font-family: inherit;\n  padding: 12px 16px;\n  background: rgba(16, 34, 30, 0.65);\n  border: 1px solid rgba(72, 209, 204, 0.18);\n  border-radius: 10px;\n  color: #fff;\n  font-size: 13.5px;\n  line-height: 1.5;\n  outline: none;\n  resize: vertical;\n  margin-bottom: 14px;\n  transition: all 0.2s ease;\n}\n\n.post-composer-card .composer-input-title:disabled,\n.post-composer-card .composer-textarea:disabled,\n.comment-reply-form .reply-input:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n  background: rgba(255, 255, 255, 0.02);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.composer-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n/* Composer Attachment Buttons Toolbar */\n.composer-attachment-buttons {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.btn-composer-attach {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  background: rgba(72, 209, 204, 0.08);\n  border: 1px solid rgba(72, 209, 204, 0.25);\n  color: #48D1CC;\n  font-size: 12.5px;\n  font-weight: 600;\n  padding: 8px 14px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.btn-composer-attach:hover:not(:disabled) {\n  background: rgba(72, 209, 204, 0.18);\n  border-color: #48D1CC;\n  transform: translateY(-1px);\n}\n\n.btn-composer-attach.attached {\n  background: rgba(72, 209, 204, 0.22);\n  border-color: #48D1CC;\n  color: #fff;\n  box-shadow: 0 0 12px rgba(72, 209, 204, 0.2);\n}\n\n.btn-composer-attach:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  border-color: rgba(255, 255, 255, 0.08);\n  color: #64748b;\n}\n\n/* Composer Attachments Tray */\n.composer-attachments-tray {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.composer-attachment-preview {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  border-radius: 12px;\n  background: rgba(16, 34, 30, 0.7);\n  border: 1px solid rgba(72, 209, 204, 0.25);\n  animation: fadeInAttachment 0.2s ease;\n}\n\n@keyframes fadeInAttachment {\n  from { opacity: 0; transform: translateY(-4px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.composer-attachment-preview.ballot-preview {\n  border-left: 3px solid #48D1CC;\n}\n\n.composer-attachment-preview.shorts-preview {\n  border-left: 3px solid #2dd4bf;\n}\n\n.composer-preview-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 9px;\n  background: rgba(72, 209, 204, 0.12);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.composer-preview-media {\n  width: 36px;\n  height: 48px;\n  border-radius: 6px;\n  overflow: hidden;\n  background: #000;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.composer-preview-thumb {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.composer-preview-thumb-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.composer-preview-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.composer-preview-label {\n  display: block;\n  font-size: 10.5px;\n  font-weight: 700;\n  color: #48D1CC;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 2px;\n}\n\n.composer-preview-title {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #f8fafc;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.composer-preview-sub {\n  font-size: 11.5px;\n  color: #94a3b8;\n  margin-top: 2px;\n  display: block;\n}\n\n.btn-composer-remove-attachment {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #94a3b8;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n}\n\n.btn-composer-remove-attachment:hover {\n  background: rgba(239, 68, 68, 0.2);\n  border-color: rgba(239, 68, 68, 0.4);\n  color: #f87171;\n}\n\n.btn-post-submit {\n  background: #3bb3ae;\n  color: #091714;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 9px 20px;\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.btn-post-submit:hover:not(:disabled) {\n  background: #4de3cf;\n}\n\n.btn-post-submit:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  background: #2a3d38;\n  color: #718096;\n}\n\n/* Post Cards */\n.post-card {\n  background: linear-gradient(180deg, #10221e 0%, #091714 100%);\n  border: 1px solid rgba(72, 209, 204, 0.18);\n  border-radius: 16px;\n  padding: 22px;\n  margin-bottom: 20px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n}\n\n.post-card.announcement {\n  border-left: 4px solid #f56565;\n}\n\n.post-card.pinned {\n  border-left: 4px solid #5e72e4;\n}\n\n.post-badges-row {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.badge-announcement {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: rgba(245, 101, 101, 0.2);\n  color: #feb2b2;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 8px;\n}\n\n.badge-pinned {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: rgba(94, 114, 228, 0.2);\n  color: #c3dafe;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 8px;\n}\n\n.post-author-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.post-author-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.post-author-avatar-placeholder {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #3bb3ae, #15433d);\n  color: #fff;\n  font-size: 16px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.post-author-meta {\n  flex: 1;\n}\n\n.post-author-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.badge-admin-tag {\n  background: #3bb3ae;\n  color: #0d1e1a;\n  font-size: 9px;\n  font-weight: 700;\n  padding: 1px 6px;\n  border-radius: 6px;\n}\n\n.badge-tier-tag {\n  background: rgba(59, 179, 174, 0.2);\n  border: 1px solid rgba(59, 179, 174, 0.4);\n  color: #48D1CC;\n  font-size: 9px;\n  font-weight: 700;\n  padding: 1px 6px;\n  border-radius: 6px;\n}\n\n.post-date {\n  font-size: 11px;\n  color: #718096;\n}\n\n.btn-delete-post {\n  background: transparent;\n  border: none;\n  color: #718096;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  transition: color 0.2s ease;\n}\n\n.btn-delete-post:hover {\n  color: #e53e3e;\n}\n\n.btn-delete-comment {\n  background: transparent;\n  border: none;\n  color: #718096;\n  cursor: pointer;\n  padding: 2px 4px;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  transition: color 0.2s ease;\n  margin-left: 6px;\n}\n\n.btn-delete-comment:hover {\n  color: #e53e3e;\n}\n\n.post-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #fff;\n  margin: 0 0 8px 0;\n}\n\n.post-body {\n  font-size: 14px;\n  color: #cbd5e0;\n  line-height: 1.6;\n  margin: 0 0 16px 0;\n  white-space: pre-wrap;\n}\n\n/* Comments */\n.post-comments-box {\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 12px;\n  padding: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.04);\n}\n\n.comments-count-label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #718096;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 12px;\n}\n\n.comment-item {\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 8px;\n  padding: 10px 12px;\n  margin-bottom: 8px;\n}\n\n.comment-author-name {\n  font-size: 12px;\n  font-weight: 700;\n  color: #e2e8f0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 4px;\n}\n\n.comment-time {\n  font-size: 10px;\n  font-weight: 400;\n  color: #718096;\n  margin-left: auto;\n}\n\n.comment-text {\n  font-size: 13px;\n  color: #a0aec0;\n  margin: 0;\n}\n\n.comment-reply-form {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.reply-input {\n  flex: 1;\n  font-family: inherit;\n  background: rgba(16, 34, 30, 0.65);\n  border: 1px solid rgba(72, 209, 204, 0.18);\n  border-radius: 20px;\n  padding: 8px 16px;\n  color: #fff;\n  font-size: 13px;\n  outline: none;\n  transition: all 0.2s ease;\n}\n\n.reply-input:focus {\n  border-color: #48D1CC;\n  background: rgba(16, 34, 30, 0.95);\n  box-shadow: 0 0 0 3px rgba(72, 209, 204, 0.12);\n}\n\n.btn-reply-send {\n  background: #48D1CC;\n  color: #091714;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 6px 18px;\n  min-width: 68px;\n  height: 34px;\n  border-radius: 20px;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.btn-reply-send:hover:not(:disabled) {\n  background: #2dd4bf;\n}\n\n.btn-reply-send:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n/* Members Grid */\n.members-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 16px;\n}\n\n.member-card {\n  background: #141c19;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.member-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.member-avatar-placeholder {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #3bb3ae, #15433d);\n  color: #fff;\n  font-size: 18px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.member-info {\n  flex: 1;\n}\n\n.member-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n  margin: 0 0 2px 0;\n}\n\n.member-username {\n  font-size: 12px;\n  color: #718096;\n  display: block;\n  margin-bottom: 6px;\n}\n\n.member-badge-tier {\n  display: inline-flex;\n  align-items: center;\n  background: rgba(59, 179, 174, 0.2);\n  border: 1px solid rgba(59, 179, 174, 0.4);\n  color: #48D1CC;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 8px;\n}\n\n/* Loading */\n.community-detail-loading,\n.community-detail-error,\n.feed-loading,\n.feed-empty {\n  text-align: center;\n  padding: 60px 20px;\n  color: #718096;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
